<script lang="ts">
    import dayjs from 'dayjs'
    import { createEventDispatcher, onMount } from 'svelte'
    const dispatch = createEventDispatcher()
    import Content from '../_common/content.svelte'
    import LoadSpinner from '../_common/load-spinner.svelte'
    import DateSelect from '../_common/date-select.svelte'
    import { RecipientsRepository } from '../../modules/brokerApi/recipients/recipients.repository'
    import { RecipientsService } from '../../modules/brokerApi/recipients/recipients.service'
    import type { Recipient } from '../../modules/brokerApi/recipients/recipient'
    import Zgrid from '../_common/z/zgrid.svelte'
    import { GridBadge, GridBadgeClassEnum, GridButton, GridClass, GridCol, GridColTypeEnum, GridLine } from '../_common/z/zgrid'
    import { faFileLines, faSyncAlt } from '@fortawesome/free-solid-svg-icons'
    import Zact from '../_common/z/zact.svelte'
    import { SERVICE } from '../../modules/brokerApi/creatives/creative.enum'
    import Zbutton from '../_common/z/zbutton.svelte'
    import Popover from '../_common/popover.svelte'
    // ##############################################################################################################

    const rep = new RecipientsRepository()
    const service = new RecipientsService(rep)
    let entities: Recipient[] = []
    let dates: { from: Date; to: Date } = window.api.utils.dates.today()
    dates.from.setHours(0, 0, 0)
    dates.to.setHours(23, 59, 59)

    let allowRetry = false

    let lastRetry = null
    async function retry(recipientId: string) {
        if (!confirm('Deseja mesmo reenviar essa mensagem?')) return
        lastRetry = recipientId
        const result = await window.api.brokers.recipient.retry(recipientId)
        window.alert('Reenvio solicitado.\nA mensagem aparecerá na fila em alguns instantes. Aguarde!')
        setTimeout(loadEntities, 2000)
        console.log('result', result)
    }

    async function retryAll() {
        try {
            show = true
            if (!confirm('Deseja mesmo reenviar todas as mensagens com falha?')) return
            lastRetry = null
            for (const item of entities) {
                if (!isRetryAllowed(item)) continue
                const result = await window.api.brokers.recipient.retry(item.recipientId)
                console.log('Reenviando', item.toNormalized)
                await new Promise((resolve) => setTimeout(resolve, 150))
            }
            setTimeout(loadEntities, 2000)
            window.alert('Reenvio solicitado.\nAs mensagens aparecerão na fila em alguns instantes. Aguarde!')
        } catch (error) {
        } finally {
            show = false
        }
    }

    let withRetry = false
    async function loadEntities() {
        try {
            show = true
            entities = []
            const dt = {
                from: dates?.from || undefined,
                to: dates?.to || undefined,
            }
            console.log('dt', dt)
            entities = await service.getAll(dt)
            const nowInMinutes = new Date().getTime() / 1000 / 60
            withRetry = entities.some((el) => el.status === 195 && nowInMinutes - new Date(el.updatedAt).getTime() / 1000 / 60 < 35)
            loadGrid()
            console.log('recipients', entities)
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function evaluateError(error) {
        window.error(error)
    }

    function dateChanged(event) {
        dates = event.detail
        loadEntities()
    }

    let show = false

    onMount(async () => {
        await loadEntities()
    })

    function friendlyStatus(status: string) {
        if (status === 'processing') return 'na fila'
        if (status === 'gw_sent') return 'enviado'
        if (status === 'gw_confirmed') return 'entregue'
        if (status === 'forwarded') return 'encaminhado'
        if (status === 'expired') return 'expirou'
        if (status === 'gw_unknown') return 'desconhecido'
        if (status === 'gw_retry') return 'reenviado'
        if (status === 'gw_expired') return 'expirou'
        if (status === 'scheduled') return 'agendado'
        if (status === 'canceled_nofunds') return 'sem saldo'
        if (status === 'gw_error') return 'erro'
        return status
    }

    function isRetryAllowed(item) {
        if (item.service !== SERVICE.WA && item.service !== SERVICE.EVO) return false
        if (item.status === 110) return false
        if ((item.status >= 100 && item.status <= 199 && item.status !== 195) || item.status === 255) return true
        return false
    }

    // mensagem cujo retorno do provedor está aberto no popover
    let logItem: Recipient = null
    function showLog(item: Recipient) {
        logItem = item
    }

    let grid: GridClass = new GridClass()
    function loadGrid() {
        // grid
        allowRetry = false
        grid = new GridClass()
        // grid head
        grid.title = 'Caixa de Saída'
        grid.subtitle = ''
        grid.fontSize = '12px'
        grid.cols.push(new GridCol({ content: 'Tipo' }))
        grid.cols.push(new GridCol({ content: 'Status', type: GridColTypeEnum.badge }))
        grid.cols.push(new GridCol({ content: 'Criado', type: GridColTypeEnum.datetime, class: 'fix-w_150' }))
        grid.cols.push(new GridCol({ content: 'Agendado', type: GridColTypeEnum.datetime, class: 'fix-w_150' }))
        grid.cols.push(new GridCol({ content: 'Encaminhado', type: GridColTypeEnum.datetime, class: 'fix-w_150' }))
        //grid.cols.push(new GridCol({ content: 'Atualizado', type: GridColTypeEnum.datetime, class: 'fix-w_150' }))
        grid.cols.push(new GridCol({ content: 'Destino', type: GridColTypeEnum.phone }))
        grid.cols.push(new GridCol({ content: 'Mensagem', class: 'text-muted' }))
        grid.cols.push(new GridCol({ content: '', type: GridColTypeEnum.button }))
        // grid lines
        for (const item of entities) {
            let btn = null
            //item.status === 110 = expirou. pois o reenviar vai preservar o expiresAt
            if (isRetryAllowed(item)) {
                btn = new GridButton({
                    callback: () => retry(item.recipientId),
                    icon: faSyncAlt,
                    label: 'Reenviar',
                })
                allowRetry = true
            }
            // o provedor só devolve texto quando algo não saiu como esperado (erro, expiração,
            // limite); mensagens enviadas normalmente não têm o que mostrar
            let btnLog = null
            if (item.integrationStatus?.trim()) {
                btnLog = new GridButton({
                    callback: () => showLog(item),
                    icon: faFileLines,
                    label: 'Log',
                })
            }
            let line: GridLine = new GridLine()
            line.slots.push({ content: getService(item.service) })
            line.slots.push({
                content: new GridBadge({ label: friendlyStatus(item.statusLabel.toLowerCase()), class: getStatusClass(item.statusLabel.toLowerCase()) }),
            })
            line.slots.push({ content: item.createdAt })
            line.slots.push({ content: item.scheduledAt })
            line.slots.push({ content: item.forwardedAt })
            //line.slots.push({ content: item.updatedAt })
            line.slots.push({ content: item.toNormalized })
            line.slots.push({ content: formatMessage(item.message) })
            line.slots.push({ content: [btnLog, btn].filter((el) => !!el) })
            grid.lines.push(line)
        }
    }

    function getService(service: string) {
        if (service === 'sms') return 'SMS'
        if (service === 'whatsapp') return 'WhatsApp'
        if (service === 'evo') return 'WhatsApp'
        if (service === 'email') return 'E-Mail'
        if (service === 'push') return 'Notificação'
        return service
    }

    function getStatusClass(status) {
        if (status === 'processing') return GridBadgeClassEnum.badge_default
        if (status === 'gw_sent') return GridBadgeClassEnum.badge_success
        if (status === 'gw_confirmed') return GridBadgeClassEnum.badge_success
        if (status === 'forwarded') return GridBadgeClassEnum.badge_default
        if (status === 'expired') return GridBadgeClassEnum.badge_alert
        if (status === 'gw_unknown') return GridBadgeClassEnum.badge_default
        if (status === 'gw_retry') return GridBadgeClassEnum.badge_default
        if (status === 'gw_expired') return GridBadgeClassEnum.badge_default
        if (status === 'scheduled') return GridBadgeClassEnum.badge_default
        if (status === 'canceled_nofunds') return GridBadgeClassEnum.badge_default
        if (status === 'gw_error') return GridBadgeClassEnum.badge_danger
        return GridBadgeClassEnum.badge_default
    }

    function formatMessage(m: string) {
        m = m.replaceAll('\n', ' ')
        if (m.length > 250) {
            m = m.substring(0, 247)
            m += '...'
        }
        m = window.api.utils.utils.sanitizeHTMLTagsIntoSpace(m)
        return m
    }
</script>

{#if logItem}
    <Popover title="Log do envio" width="640px" on:close={() => (logItem = null)}>
        <div class="log-box">
            <div class="log-meta">
                <span>{friendlyStatus(logItem.statusLabel?.toLowerCase())}</span>
                <span>{logItem.toNormalized}</span>
                {#if logItem.forwardedAt}
                    <span>{dayjs(logItem.forwardedAt).format('DD/MM/YYYY HH:mm:ss')}</span>
                {/if}
            </div>
            <div class="log-text">{logItem.integrationStatus}</div>
        </div>
    </Popover>
{/if}

<Content footer={true}>
    <Zact>
        <DateSelect startFrom={dates.from} startTo={dates.to} on:change={dateChanged} />
        <div class="spacer" />
        <Zbutton icon={faSyncAlt} on:click={retryAll} label="Reenviar todos com falha"></Zbutton>
    </Zact>
    {#if withRetry}
        <div class="alert alert-warning text-center mt-2">
            Há mensagens com o status <code>reenviado</code>. Essas mensagens foram colocadas na fila para novo envio.
            <br />Pode ser que leve até 30 minutos para que as mensagens reenviadas apareçam na fila.
        </div>
    {/if}
    <Zgrid class="h-space" {grid} />

    <LoadSpinner delay={0} {show} />
</Content>

<style>
    .log-box {
        padding: 16px;
    }
    .log-meta {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        font-size: 13px;
        opacity: 0.7;
        margin-bottom: 12px;
    }
    /* o retorno do provedor pode ser longo e sem espaços (ids, urls): quebra em qualquer ponto */
    .log-text {
        font-family: Consolas, Monaco, monospace;
        font-size: 13px;
        white-space: pre-wrap;
        overflow-wrap: anywhere;
        user-select: text;
    }
</style>
